module.exports = __webpack_public_path__ + "img/Ekko-Header-2-Left@2x.1e798326.png";